<template>
  <div>
    <div style="background: #fff; padding: 10px 0; height: 100%">
      <div class="sd_person_button">
        <span @click="setType(1)" :class="{ active: type == 1 }">全部</span>
        <span @click="setType(2)" :class="{ active: type == 2 }">本项目</span>
        <span @click="setType(3)" :class="{ active: type == 3 }">其他项目</span>
      </div>
      <div style="display: flex; width: 100%; height: calc(100% - 50px)">
        <div
          id="person_canvas1"
          class="echart"
          style="width: 50%; height: 100%"
        ></div>
        <div
          id="person_canvas2"
          class="echart"
          style="width: 50%; height: 100%; margin: 0 0 0 1rem"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chartObj2: null,
      chartObj3: null,
      type: 1,
      option2: {
        //color:colors,
        tooltip: {
          trigger: "item",
        },
        legend: {
          left: "50",
          top: "center",
        },
        series: {
          type: "sunburst",
          data: [],
          radius: [20, "100%"],
          itemStyle: {
            borderRadius: 7,
            borderWidth: 2,
          },
          label: {
            show: true,
            fontSize: 10
          },
        },
      },
      option3: {
        xAxis: {
          type: "category",
          data: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
          boundaryGap: false,
          splitLine: {
            show: true,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          type: "category",
          data: [
            "信息应用意识",
            "信息安全意识",
            "信息感知意识",
            "信息社会责任",
            "信息法律法规",
            "信息应用技能",
            "信息科学知识",
            "信息思维",
            "信息行为",
          ],
          axisLine: {
            show: false,
          },
        },
        grid: {
          left: '20%',
          bottom: '10%',
          right: '10%',
          top: '10%',
        },
        series: [
          {
            name: "Punch Card",
            type: "scatter",
            symbolSize: function (val) {
              return val[2] * 2;
            },
            data: [],
            animationDelay: function (idx) {
              return idx * 5;
            },
          },
        ],
      },
    };
  },
  methods: {
    setChart() {
      // 雷达图显示的标签
      let newPromise = new Promise((resolve) => {
        resolve();
      });
      //然后异步执行echarts的初始化函数
      newPromise.then(() => {
        const chartObj2 = this.$echarts.init(
          //劳动课程
          this.$el.querySelector("#person_canvas1")
        );
        this.option2.series.data = [
          {
            name: "信息意识",
            value: 15,
            children: [
              {
                name: "信息应用意识",
                value: this.randomNum(1, 5),
              },
              {
                name: "信息安全意识",
                value: this.randomNum(1, 5),
              },
              {
                name: "信息感知意识",
                value: this.randomNum(1, 5),
              },
            ],
          },
          {
            name: "信息社会责任",
            value: 15,
            children: [
              {
                name: "信息伦理道德",
                value: this.randomNum(1, 5),
              },
              {
                name: "信息法律法规",
                value: this.randomNum(1, 10),
              },
            ],
          },
          {
            name: "信息知识与技能",
            value: 15,
            children: [
              {
                name: "信息应用技能",
                value: 5,
              },
              {
                name: "信息科学知识",
                value: 10,
              },
            ],
          },
          {
            name: "信息思维与行为",
            value: 15,
            children: [
              {
                name: "信息思维",
                value: this.randomNum(1, 10),
              },
              {
                name: "信息行为",
                value: this.randomNum(1, 5),
              },
            ],
          },
        ];
        const chartObj3 = this.$echarts.init(
          //劳动课程
          this.$el.querySelector("#person_canvas2")
        );
        let data = [];
        for (var i = 1; i < 10; i++) {
          for (var j = 0; j < 9; j++) {
            var x = i;
            var y = j;
            var z = this.randomNum(0, 10);
            data.push([x, y, z]);
          }
        }
        this.option3.series[0].data = data;
        // console.log(this.option.series[0].data);
        // 初始化雷达图
        this.chartObj2 = chartObj2;
        this.chartObj3 = chartObj3;
        this.chartObj2.setOption(this.option2);
        this.chartObj3.setOption(this.option3);
      });
      let _this = this;
      window.addEventListener("resize", () => {
        if (_this.chartObj2) {
          _this.chartObj2.resize();
          _this.chartObj3.resize();
        }
      });
    },
    randomNum(minNum, maxNum) {
      switch (arguments.length) {
        case 1:
          return parseInt(Math.random() * minNum + 1, 10);
          break;
        case 2:
          return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
          break;
        default:
          return 0;
          break;
      }
    },
    setType(type) {
      this.type = type;
      this.option2.series.data = [
        {
          name: "信息意识",
          value: 15,
          children: [
            {
              name: "信息应用意识",
              value: this.randomNum(1, 5),
            },
            {
              name: "信息安全意识",
              value: this.randomNum(1, 5),
            },
            {
              name: "信息感知意识",
              value: this.randomNum(1, 5),
            },
          ],
        },
        {
          name: "信息社会责任",
          value: 15,
          children: [
            {
              name: "信息伦理道德",
              value: this.randomNum(1, 5),
            },
            {
              name: "信息法律法规",
              value: this.randomNum(1, 10),
            },
          ],
        },
        {
          name: "信息知识与技能",
          value: 15,
          children: [
            {
              name: "信息应用技能",
              value: 5,
            },
            {
              name: "信息科学知识",
              value: 10,
            },
          ],
        },
        {
          name: "信息思维与行为2",
          value: 15,
          children: [
            {
              name: "信息思维",
              value: this.randomNum(1, 10),
            },
            {
              name: "信息行为",
              value: this.randomNum(1, 5),
            },
          ],
        },
      ];
      this.chartObj2.setOption(this.option2);
      let data = [];
      for (var i = 1; i < 10; i++) {
        for (var j = 0; j < 9; j++) {
          var x = i;
          var y = j;
          var z = this.randomNum(0, 10);
          data.push([x, y, z]);
        }
      }
      this.option3.series[0].data = data;
      this.chartObj3.setOption(this.option3);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.setChart();
    });
  },
};
</script>

<style scoped>
.sd_person_button {
  font-size: 16px;
  display: flex;
  margin-bottom: 10px;
}

.sd_person_button span {
  margin-left: 20px;
  padding: 0 0 6px;
  cursor: pointer;
}

.sd_person_button .active {
  border-bottom: 2px solid rgb(30, 146, 255);
  color: rgb(30, 146, 255);
}
</style>


// WEBPACK FOOTER //
// src/components/pages/components/report/studentAbility.vue